import React from 'react'
import { RxPlusCircled } from '@react-icons/all-files/rx/RxPlusCircled'
import type { Group } from 'types/group'
import type { PlaylistId } from 'types/playlist'
import type { Track } from 'types/track'
import { Flex } from 'components/ds'
import Submenu from 'components/track-actions/submenu/dropdown-submenu'
import AddToChannel from './add-to-channel'
import AddToPlaylist from './add-to-playlist'
import AddToShortlist from './add-to-shortlist'

type Props = {
  track: Track
  excludeShortlistId: string | null | undefined
  sourceShortlistId?: string | null | undefined
  sourcePlaylistId?: PlaylistId | null | undefined
  closeMenu: () => void
  group?: Group | null | undefined
  disabled: boolean
  addToCustomGroup: boolean
}

const AddTrackToOption = ({
  group,
  closeMenu,
  track,
  sourcePlaylistId,
  sourceShortlistId,
  disabled,
  addToCustomGroup,
}: Props): React.ReactNode => (
  <Submenu
    title={
      <Flex align="center" gap="2">
        <RxPlusCircled />
        Add to
      </Flex>
    }
    links={[
      <AddToPlaylist
        key="add-to-playlist"
        track={track}
        closeMenu={closeMenu}
      />,
      <AddToChannel
        key="add-to-channel"
        track={track}
        group={group}
        sourcePlaylistId={sourcePlaylistId}
        closeMenu={closeMenu}
        addToCustomGroup={addToCustomGroup}
        disabled={disabled}
      />,
      <AddToShortlist
        key="add-to-shortlist"
        track={track}
        excludeShortlistId={sourceShortlistId ?? undefined}
        sourceGroupId={group ? group.id : null}
        sourceGroupType={group ? group.group_type : null}
        sourcePlaylistId={sourcePlaylistId}
        closeMenu={closeMenu}
      />,
    ]}
  />
)

export default AddTrackToOption
